// Lib Imports
import React, { useContext } from 'react';
import { Box, ThemeContext } from 'grommet';
import Phone from 'react-phone-input-2';
import PropTypes from 'prop-types';
import 'react-phone-input-2/lib/high-res.css';
import useTimeZone from 'granite-admin/utils/useTimeZone';
import styled from 'styled-components';
const {
  country
} = useTimeZone();
const Parent = styled(Box)`
  ${({
  disabled
}) => disabled && `
    opacity:0.5;
  `}
  .react-tel-input .flag-dropdown {
    background: none;
    border: none;
    // z-index: 4;
    &.open {
      z-index: unset;
    }
    & .selected-flag {
      z-index: 2;
    }
    & ul.country-list {
      z-index: 4;
    }
  }
`;
const PhoneInput = ({
  value,
  onChange,
  disabled,
  onBlur,
  inputProps,
  countryCodeEditable
}) => {
  const theme = useContext(ThemeContext);
  return /*#__PURE__*/React.createElement(Parent, {
    disabled: disabled
  }, /*#__PURE__*/React.createElement(Phone, {
    inputProps: {
      ...inputProps
    },
    onBlur: onBlur,
    country: value?.countryCode,
    value: value?.number,
    countryCodeEditable: countryCodeEditable ?? theme?.phoneInput?.countryCodeEditable ?? false,
    enableSearch: true,
    disabled: disabled,
    inputStyle: {
      width: '100%',
      background: theme.global.colors['bgColor'],
      color: theme.global.colors['text'],
      height: '38px'
    },
    dropdownStyle: {
      color: theme.global.colors['darkText']
    },
    buttonStyle: {
      background: theme.global.colors['bgColor']
    },
    onChange: (val, country) => {
      onChange({
        // if country is switched, we'll set number to "" as onChange is returning previously entered value
        number: country.countryCode !== value.countryCode ? '' : val,
        dialCode: country.dialCode,
        countryCode: country.countryCode
      });
    }
  }));
};
PhoneInput.defaultProps = {
  value: {
    number: '',
    dialCode: '1',
    countryCode: country?.toLowerCase()
  },
  onBlur: () => {},
  inputProps: {}
};
PhoneInput.propTypes = {
  value: PropTypes.object,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  countryCodeEditable: PropTypes.bool
};
PhoneInput.displayName = 'PhoneInput';
export default PhoneInput;